// Custom JavaScript for Wine Lamborghini
document.addEventListener('DOMContentLoaded', function () {
  // Initialize accordions
  function initializeAccordions() {
    const toggles = document.querySelectorAll('.accordion-toggle');

    toggles.forEach(function(toggle) {
      const content = toggle.nextElementSibling;
      
      // Skip if already initialized
      if (toggle.hasAttribute('data-accordion-initialized')) {
        return;
      }
      toggle.setAttribute('data-accordion-initialized', 'true');
      
      // Set initial state based on whether button has 'active' class
      if (toggle.classList.contains('active')) {
        content.style.height = 'auto';
        const initialHeight = content.scrollHeight + 'px';
        content.style.height = initialHeight;
      } else {
        content.style.height = '0px';
        content.style.opacity = '0';
      }
      
      toggle.addEventListener('click', function () {
        const isActive = this.classList.contains('active');
        
        if (isActive) {
          // Closing animation
          content.style.height = content.scrollHeight + 'px';
          content.offsetHeight; // Force reflow
          content.style.height = '0px';
          content.style.opacity = '0';
        } else {
          // Opening animation
          content.style.height = content.scrollHeight + 'px';
          content.style.opacity = '1';
        }
        
        this.classList.toggle('active');
      });
      
      // After transition ends, set height to auto for responsive content
      content.addEventListener('transitionend', function(e) {
        if (e.propertyName === 'height' && toggle.classList.contains('active')) {
          content.style.height = 'auto';
        }
      });
    });
  }

  initializeAccordions();
  
  // Re-initialize accordions when cart drawer content changes
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function() {
      initializeAccordions();
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Prevent double submission of membership form and handle AJAX submission
  const membershipForm = document.querySelector('.membership-product-form');
  if (membershipForm) {
    membershipForm.addEventListener('submit', function(e) {
      const membershipVariantId = membershipForm.getAttribute('data-membership-variant-id');
      e.preventDefault();
      
      const button = membershipForm.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.classList.add('disabled');
      }
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const alreadyInCart = cart.items.some(item => item.variant_id == membershipVariantId);
          if (alreadyInCart) {
            alert('Membership is already in your cart.');
            if (button) {
              button.disabled = false;
              button.classList.remove('disabled');
            }
          } else {
            // Add to cart via AJAX instead of form submission
            const formData = new FormData(membershipForm);
            const params = new URLSearchParams(formData);
            
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: params
            })
            .then(response => {
              if (!response.ok) {
                return response.text().then(text => {
                  console.error('Error response:', text);
                  throw new Error(`HTTP error! status: ${response.status}`);
                });
              }
              return response.json();
            })
            .then(data => {
              console.log('Successfully added to cart:', data);
              
              // Don't hide the section, just reload to update the cart
              // The Liquid template will handle showing/hiding based on cart contents
              
              // Simple reload of the cart drawer content
              setTimeout(() => {
                window.location.reload();
              }, 500);
              
              if (button) {
                button.disabled = false;
                button.classList.remove('disabled');
                button.textContent = 'Added to cart!';
              }
            })
            .catch(error => {
              console.error('Error adding membership to cart:', error);
              console.error('Form data:', Object.fromEntries(params));
              alert('There was an error adding the membership to your cart. Please check the console for details.');
              if (button) {
                button.disabled = false;
                button.classList.remove('disabled');
              }
            });
          }
        });
    });
  }

  // Auto-correct membership quantity to 1 if needed
  const membershipVariantId = document.querySelector('.membership-product-form')?.getAttribute('data-membership-variant-id');
  if (membershipVariantId) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const membershipItem = cart.items.find(item => item.variant_id == membershipVariantId);
        if (membershipItem && membershipItem.quantity > 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: membershipItem.key,
              quantity: 1
            })
          }).then(() => {
            window.location.reload();
          });
        }
      });
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   const buttons = document.querySelectorAll('.add-membership-to-cart');

//   buttons.forEach(function (button) {
//     button.addEventListener('click', function () {
//       const variantId = button.getAttribute('data-variant-id');
//       const sellingPlanId = button.getAttribute('data-selling-plan-id');

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           items: [{
//             id: parseInt(variantId),
//             quantity: 1,
//             selling_plan: sellingPlanId ? parseInt(sellingPlanId) : undefined
//           }]
//         })
//       })
//       .then(response => response.json())
//       .then(data => {
//         console.log("Product with selling plan added:", data);
//         // location.reload(); 
//       .catch(error => {
//         console.error("Error adding to cart:", error);
//       });
//     });
//   });
// });


